import * as React from 'react';
import {Button, Stack, Typography, Container, Breadcrumbs, Box} from "@mui/material";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import {useEffect} from "react";
import {withNavigation} from "../navigation/navigation";
import {useNavigate} from 'react-router-dom';
import GameButton from './GameButton';

/* export default function Game({setShowNav}) {
    const {mode} = useDarkMode();
    useEffect(() => {
        setShowNav(true);
    }, [])


    return (
        <Card class={'sideMenuCard'} style={{backgroundColor: mode.settings.cardBackgroundColor}}>
            <Stack direction="column" justifyContent="left" alignItems="center" spacing={1} padding={1}>
                <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} sx={{marginTop:'7px'}}>
                    <img src={`/assets/icon/game-header.png`} alt={'Image de présentation des jeux'}/>
                    <Typography variant={'subtitle2'} sx={{color:'#DD809D'}}>JEUX</Typography>
                </Stack>
                <img src={`/assets/icon/card-divider.png`} alt={'card-divider'} style={{marginTop:'7px'}}/>
                <GameButton text={'Simili'} link={'https://www.stimart.com/StimartJSP/edithSingleMode.jsp?forceGame=simili&source=ohs'}/>
                <GameButton text={'Quizzle'} link={'https://www.stimart.com/StimartJSP/edithSingleMode.jsp?forceGame=quizzle&source=ohs'}/>
                <GameButton text={'Proverb'} link={'https://www.stimart.com/StimartJSP/edithSingleMode.jsp?forceGame=proverb&source=ohs'}/>
                <GameButton text={'Intrus'} link={'https://www.stimart.com/StimartJSP/edithSingleMode.jsp?forceGame=intrus&source=ohs'}/>
                <GameButton text={'Cook'} link={'https://www.stimart.com/StimartJSP/edithSingleMode.jsp?forceGame=cook&source=ohs'}/>
            </Stack>
        </Card>
    )
}

 */
const Game = ({setShowNav}) => {
    const navigate = useNavigate();
    const {mode} = useDarkMode();


    const breadcrumbs = [
        <Typography
          className={'breadcrumbs'}
          variant={'body2'}
          onClick={() => navigate('/')}
          style={{color: mode.settings.breadcrumbColor1}}>
          Accueil
        </Typography>,
        <Typography variant={'body2'} style={{color: mode.settings.textColor3}}>
          Jeux
        </Typography>,
      ];

    useEffect(() => {
        setShowNav(false);
    }, [])

    return (
        <Container className={'container game-container'}>
            <Breadcrumbs
                separator="›"
                aria-label="navigation"
                style={{color: mode.settings.textColor3}}>
                {breadcrumbs}
            </Breadcrumbs>
            <Stack direction="row" justifyContent="flex-start" gap={2} flexWrap={"wrap"} spacing={5} padding={1}>
                <GameButton
                    text={'Simili'}
                    link={'https://www.stimart.com/StimartJSP/edithSingleMode.jsp?forceGame=simili&source=ohs'}
                    icon={"/assets/icon/jeux-bleu.png"}
                    img={"/assets/icon/simili_icon.png"}
                />
                <GameButton
                    text={'Quizzle'}
                    link={'https://www.stimart.com/StimartJSP/edithSingleMode.jsp?forceGame=quizzle&source=ohs'}
                    icon={"/assets/icon/jeux-bleu.png"}
                    img={"/assets/icon/quizzle_icon.png"}
                />
                <GameButton
                    text={'Proverb'}
                    link={'https://www.stimart.com/StimartJSP/edithSingleMode.jsp?forceGame=proverb&source=ohs'}
                    icon={"/assets/icon/jeux-bleu.png"}
                    img={"/assets/icon/proverb_icon.png"}
                />
                <GameButton
                    text={'Intrus'}
                    link={'https://www.stimart.com/StimartJSP/edithSingleMode.jsp?forceGame=intrus&source=ohs'}
                    icon={"/assets/icon/jeux-bleu.png"}
                    img={"/assets/icon/intrus_icon.png"}
                />
                <GameButton
                    text={'Cook'}
                    link={'https://www.stimart.com/StimartJSP/edithSingleMode.jsp?forceGame=cook&source=ohs'}
                    icon={"/assets/icon/jeux-bleu.png"}
                    img={"/assets/icon/cook_icon.png"}
                />
            </Stack>
        </Container>
    );
};

export default withNavigation(Game);
